import React from 'react'
import PropTypes from 'prop-types'

import { Card } from 'semantic-ui-react'

import FAPictureCardActions from './FAPictureCardActions'
import FAPictureCardCustomers from './FAPictureCardCustomers'
import FAPictureCardInformation from './FAPictureCardInformation'
import FAPictureCardPicture from './FAPictureCardPicture'

const FAPictureCard = ({ index, onClick, picture }) => {
  return (
    <Card fluid>
      <FAPictureCardPicture index={index} onClick={onClick} picture={picture} />

      <FAPictureCardInformation picture={picture} />

      <FAPictureCardCustomers picture={picture} />

      <FAPictureCardActions picture={picture} />
    </Card>
  )
}

FAPictureCard.propTypes = {
  index: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  picture: PropTypes.object.isRequired,
}

export default FAPictureCard
